import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { LoginService } from "../services/login.service";
import { from, switchMap } from "rxjs";

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  return from(inject(LoginService).getAPIToken())
    .pipe(
      switchMap(authToken => {
        const authReq = (authToken) ? req.clone({ setHeaders: { Authorization: authToken } }) : req;
        return next(authReq);
      })
    );
}
